import React, {useState} from 'react';
import { styled } from "styled-components";
import { handlePasteClean } from '~/utils/textCleaner';

const Wrapper = styled.div`
  padding-right: 20px;
  margin-bottom: 12px;
  
  label {
    
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
  }
`;

const DefaultInput = styled.input`
  border: 0px solid;
  display: block;
  width: -webkit-fill-available;
  margin-top: 8px;
  background: #F5F5F5;
  padding: 10px 15px 10px 15px;
  gap: 10px;
  border-radius: 5px;
`;

const Input = ({ id, label, placeholder, content, onChangeEvent, type }) => {
  const [value, setValue] = useState(content || '');

  const onChange = (e) => {
    setValue(e.target.value);
    if (onChangeEvent) {
      onChangeEvent(id, e.target.value, type);
    }
  };

  const onPaste = (e) => {
    handlePasteClean(e, setValue, onChangeEvent, id, type);
  };

  return (
    <Wrapper>
      <label>{label ? `${label}: ` : ''}</label>
      <DefaultInput onChange={onChange} onPaste={onPaste} value={value} placeholder={placeholder || 'Type here'} />
    </Wrapper>
  );
};

export default Input;
